import React from 'react';
import styles from './FAQ.module.css';
import Accordion from 'react-bootstrap/Accordion';
import FAQS from './FAQ.string';
import { Button } from 'react-bootstrap';

const quotes = [
  {
    id: 1,
    name: 'Nurbek',
    quote: 'I found the website very intuitive to use, and the ability to create custom domains is amazing. ',
    img: 'quote-auth-4.jpg'
  },
  {
    id: 2,
    name: 'Jonathan',
    quote: 'The platform is awesome I recently just found out it existed!',
    img: 'quote-auth-2.jpg'
  },
  {
    id: 3,
    name: 'Cliff',
    quote: 'Phil was very knowledgeable and explained everything clearly.',
    img: 'quote-auth-3.jpg'
  },
  {
    id: 4,
    name: 'Vaidy',
    quote: 'I love your service, its so simple to use!',
    img: 'quote-auth-1.jpg'
  },
  {
    id: 5,
    name: 'Sal',
    quote: 'Your platform is awesome, and I enjoyed taking it out for a spin',
    img: 'quote-auth-6.jpg'
  },
  {
    id: 6,
    name: 'Jessica',
    quote: "For prototyping & sharing in the remote work setting, I don't see any better alternative.",
    img: 'quote-auth-7.jpg'
  },
  {
    id: 7,
    name: 'Bret',
    quote: "I love the platform! It's light and quick, really great for client demos.",
    img: 'quote-auth-5.jpg'
  }
];

const QuoteCard = ({ quote, name, img }) => (
  <div className={styles.quoteCard}>
    <div className="opacity-8">"{quote}"</div>
    <div className={styles.quoteAuthor}>
      <img className="me-2 round-20" src={`assets/img/${img}`} height={15} width={15} />
      <span>{name}</span>
    </div>
  </div>
);

const FAQ = () => (
  <div className={styles.container}>
    <div className={styles.quoteList}>
      <div style={{ marginTop: 40 }}>
        <div className="mb-4 opacity-50 font-22 font-weight-lighter">
          5/5 <br />
          ⭐️⭐️⭐️⭐️⭐️
        </div>
        {quotes.slice(0, 3).map(({ id, ...rest }) => (
          <QuoteCard key={id} {...rest} />
        ))}
      </div>
      <div>
        {quotes.slice(3, 6).map(({ id, ...rest }) => (
          <QuoteCard key={id} {...rest} />
        ))}
      </div>
    </div>
    <div className={styles.faqList}>
      <h2>Frequently Asked Questions</h2>
      <Accordion className={styles.accordion} flush>
        {FAQS.map(({ q, a }, i) => (
          <Accordion.Item key={i} eventKey={i}>
            <Accordion.Header className="font-18">{q}</Accordion.Header>
            <Accordion.Body className="text-start font-18">{a}</Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
      <div className="mt-5 pt-5 ms-auto me-auto">
        <h3 className="bold">Ready to share your work?</h3>
        <div className="m-auto">
          <a href="#home">
            <button className="button bg-purple-light white font-18">Upload for free</button>
          </a>
        </div>
      </div>
    </div>
  </div>
);

export default FAQ;
